import Vue from "vue";
import webZineService from "../services/webZineService";

const state = {
    mode: 'publish',
    selectedWebZineId: 0,
    webzine: {},
    selectedArticle: {},
    cover: {},
    categoryList: [],
    articleList: [],
    articleTotal: 0,
    sortedArticleList: [],
    articleMapByCode: {},
    webZineList: undefined,
    selectedArticleId: undefined,
};

const getters = {
    coverImgUrl(state) {
        return [
            Vue.prototype.$baseURL
            , 'image' + state.cover.server_path
            , state.cover.new_name
        ].join('/');
    },
    cover(state) {
        return state.cover;
    },
    articleList(state) {
        return state.articleList;
    },
    articleMapByCode(state) {
        return state.articleMapByCode;
    },
    categoryList(state) {
        return state.categoryList;
    },
    isPreview(state) {
        return state.mode === 'preview';
    },
    webZineList(state) {

        if(state.mode === 'preview'){
            return state.webZineList;
        }else{
            let list = [];
            if (state.webZineList && state.webZineList.length > 0) {
                list = state.webZineList;
                list.unshift({webzine_id: 'all', webzine_title: '전체'})
            }
            return list;
        }
    },
    selectedWebZineId(state) {
        return state.selectedWebZineId;
    },
    webzine(state) {
        return state.webzine;
    },
    selectedArticleId(state) {
        return state.selectedArticleId;
    },
    selectedArticle(state) {
        return state.selectedArticle;
    },
    mode(state) {
        return state.mode;
    },
    sortedArticleList(state) {
        return state.sortedArticleList;
    },
    articleTotal(state){
        return state.articleTotal;
    }
};

const mutations = {
    setWebZine(state, data) {
        state.webzine = data.webzine;
        state.cover = data.webzine.cover;
        state.categoryList = data.categoryList;
        state.articleList = data.articleList;
        state.articleMapByCode = data.articleMapByCode;

        if (data.articleList && data.articleList.length > 0) {
            data.categoryList.forEach(category => {
                data.articleList.forEach(article => {
                    if (article.webzine_category_code === category.webzine_category_code) {
                        state.sortedArticleList.push(article);
                    }
                });
            });
        } else {
            state.sortedArticleList = [];
        }

    },

    selectedWebZineId(state, webzineId) {
        state.selectedWebZineId = webzineId;
    },

    setMode(state, mode) {
        state.mode = mode;
    },
    setSelectedWebZineId(state, webzine_id) {
        state.selectedWebZineId = webzine_id;
    },
    setWebZineList(state, list) {
        state.webZineList = list;
        if (!state.selectedWebZineId) {
            state.selectedWebZineId = list[0].webzine_id
        }
    },
    setSelectedArticleId(state, article_id) {
        state.selectedArticleId = article_id;
    },
    setArticle(state, article) {
        state.selectedArticle = article;
    },
    setArticleList(state, data){
        state.articleList = data.list;
        state.articleTotal = data.total;
    },
    setCategoryList(state, categoryList) {
        state.categoryList = categoryList;
    }
};
const actions = {

    getWebZine({state, commit}, webzine_id) {
        return new Promise((resolve, reject) => {
            webZineService.getWebZine(state.mode, webzine_id)
                .then(res => {
                    commit('setWebZine', res.data);
                    resolve();
                }).catch(reject);
        });
    },

    subscribe(context, email) {
        return new Promise((resolve, reject) => {
            webZineService.subscribe(email)
                .then(resolve)
                .catch(reject);
        });
    },

    getWebZineList({commit}) {
        return new Promise((resolve, reject) => {
            webZineService.getPublishList()
                .then(res => {
                    commit('setWebZineList', res.data);
                    resolve();
                }).catch(reject)
        });
    },

    getArticle({commit, state}) {
        return new Promise((resolve, reject) => {
            webZineService.getArticleContent(state.mode, state.selectedArticleId)
                .then(res => {
                    commit('setArticle', res.data);
                    resolve();
                }).catch(reject);
        })
    },

    getArticleList({commit}, param){
        return new Promise((resolve, reject) => {
            webZineService.getArticleList(param)
                .then(res => {
                    commit('setArticleList', res.data);
                    resolve();
                }).catch(reject);
        })
    },

    getCategoryList({commit}) {
        return new Promise(((resolve, reject) => {
            webZineService.getCategoryList()
                .then(res => {
                    commit('setCategoryList', res.data);
                    resolve();
                }).catch(reject);
        }))
    }


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
